import { Link } from "react-router-dom";
import { useMe } from "../lib/me";
import { Icon } from "./icons";

// The per-project view switcher. The Project Hub (assets + services overview) is
// the first/default view; then each workflow's view — Proofing opens the report,
// Spec check the spec results. `active` is the key of the page rendering the bar.
// (Kept separate from lib/workflows WORKFLOWS — that drives the sidebar's
// per-workflow lists, where "Proofing" should still open the hub.) Manuscript
// prep is shown disabled until its module ships.
const TABS: { key: string; label: string; icon: string; path: string }[] = [
  { key: "hub", label: "Project Hub", icon: "folder", path: "" },
  { key: "proofing", label: "Proofing", icon: "headphones", path: "/report" },
  { key: "audio_analysis", label: "Spec check", icon: "audio-waveform", path: "/specs" },
  { key: "toc", label: "Table of Contents", icon: "list-tree", path: "/toc" },
];

// Noise Analytics: superadmins only, while the detector is still in the Lab.
// Sits third, right after Proofing (see `withNoise`).
const NOISE_TAB = { key: "noise", label: "Noise Analytics", icon: "flask", path: "/noise" };

function withNoise() {
  const i = TABS.findIndex((t) => t.key === "proofing") + 1;
  return [...TABS.slice(0, i), NOISE_TAB, ...TABS.slice(i)];
}

/** The same view on another project — what the title's project switcher opens,
 *  so jumping books from Spec check lands on Spec check. */
export function tabPath(key: string): string {
  return withNoise().find((t) => t.key === key)?.path ?? "";
}

export function ProjectTabs({ projectId, active }: { projectId: string; active: string }) {
  const { data: me } = useMe();
  const tabs = me?.is_superadmin ? withNoise() : TABS;
  return (
    <div className="proj-tabs" role="tablist" aria-label="Views">
      {tabs.map((t) => (
        <Link
          key={t.key}
          to={`/projects/${projectId}${t.path}`}
          role="tab"
          aria-selected={active === t.key}
          className={`proj-tab${active === t.key ? " on" : ""}`}
        >
          <Icon name={t.icon} size={16} />
          {t.label}
        </Link>
      ))}
      <span className="proj-tab soon" aria-disabled="true" title="Coming soon">
        <Icon name="document" size={16} />
        Manuscript prep
        <span className="tab-soon">soon</span>
      </span>
    </div>
  );
}
